import AppExames from "assets/app-paciente/images/exames.png";
import AppMedidas from "assets/app-paciente/images/Medidas.png";
import AppRemedios from "assets/app-paciente/images/remedios.png";
import React, { useState } from "react";

export const AplicativosTabs = () => {
  const [image, setImage] = useState(AppRemedios);
  const [index, setIndex] = useState(1);
  // AppConsultas;
  const changeTab = ({
    tabIndex,
    image,
  }: {
    tabIndex: number;
    image: string;
  }) => {
    setImage(image);
    setIndex(tabIndex);
  };
  return (
    <div className="row">
      <div className="col-4 justify-content-end d-none d-md-block">
        <img
          className="img-fluid float-right"
          id="image-slider"
          src={image}
          alt=""
        />
      </div>
      <div className="col">
        <div className="row row-cols-1">
          <div
            className={
              index === 1
                ? "col aplicativos-page__slider__text-container aplicativos-page__slider__selected"
                : "col aplicativos-page__slider__text-container"
            }
            data-index="1"
            onClick={() => changeTab({ tabIndex: 1, image: AppRemedios })}
            role="button"
          >
            <p className="title">Sua Prescrição sempre com você</p>
            <p className="content">
              Acesso total à sua Prescrição e orientações de saúde de sua equipe
              médica
            </p>
          </div>

          <div
            className={
              index === 2
                ? "col aplicativos-page__slider__text-container aplicativos-page__slider__selected"
                : "col aplicativos-page__slider__text-container"
            }
            data-index="2"
            onClick={() => changeTab({ tabIndex: 2, image: AppMedidas })}
            role="button"
          >
            <p className="title">Suas medidas e Sinais Vitais</p>
            <p className="content">
              Insira suas medidas como Pressão Arterial, Glicose, Peso e IMC,
              Temperatura e compartilhe com seu médico no prontuário ProntLife
            </p>
          </div>

          <div
            className={
              index === 3
                ? "col aplicativos-page__slider__text-container aplicativos-page__slider__selected"
                : "col aplicativos-page__slider__text-container"
            }
            data-index="3"
            onClick={() => changeTab({ tabIndex: 3, image: AppExames })}
            role="button"
          >
            <p className="title">Exame de Laboratório e Imagem</p>
            <p className="content">
              Digitalize ou tire fotos dos seus exames solicitados, assim seu
              médico poderá ter acesso na sua próxima consulta
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
